<template>
  <v-dialog
    v-model="showModal"
    max-width="600"
  >
    <v-card
      outlined
      color="#ECEFF1"
    >
      <br>
      <h2 class="title-style">
        <v-icon class="icon-style">
          mdi-clock-plus-outline
        </v-icon>Create Time Slot
      </h2>
      <v-form
        ref="form"
        v-model="isFormValid"
      >
        <v-container class="my-container-style">
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="slotName"
              :rules="[(v) => !!v || 'This field is required']"
              label="Slot Name*"
            />
          </v-col>

          <v-col
            cols="12"
          >
            <v-text-field
              v-model="slotDuration"
              outlined
              dense
              type="number"
              filled
              :rules="[(v) => !!v || 'This field is required']"
              label="Slot Duration*"
            />
          </v-col>
          <p class="text-sm-left">
            *Indicates required field
          </p>
          <v-card-actions>
            <v-btn
              class="mt-2"
              color="red darken-3"
              @click="showModal = false"
            >
              cancel
            </v-btn>
            <v-spacer />
            <v-btn
              class="mt-2"
              color="#FF3700"
              @click="createTimeSlot()"
            >
              Create
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
  </v-dialog>
</template>
<script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';

  export default {
    name: 'CreateTimeSlot',
    components: {
      'centre-spinner': spinner,
    },
    data () {
      return {
        showModal: true,
        slotName: '',
        slotDuration: null,
        loading: false,
        isFormValid: false,
      };
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    methods: {
      async createTimeSlot () {
        if (this.$refs.form.validate() === false) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Please fill the required fields before proceeding.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        this.loading = true;
        await this.$store.dispatch('digiboards/createTimeSlot', {
          name: this.slotName,
          duration: parseInt(this.slotDuration),
        }).then(response => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Time slot created successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.loading = false;
          this.$emit('success');
          this.showModal = false;
        }).catch(() => {
          this.loading = false;
        }); ;
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 21px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
  margin-right: 5px;
}
.my-container-style {
    padding-top: 24px;
}
</style>
